import React from 'react';
import { Music, Upload, Users, TrendingUp } from 'lucide-react';
import { Card } from '../common/Card';

interface Activity {
  id: string;
  type: 'upload' | 'song_live' | 'artist_added' | 'milestone';
  title: string;
  description: string;
  timestamp: string;
  metadata?: any;
}

const mockActivities: Activity[] = [
  {
    id: '1',
    type: 'song_live',
    title: 'Song went live',
    description: '"Midnight Dreams" is now available on 25 platforms',
    timestamp: '2 hours ago'
  },
  {
    id: '2',
    type: 'upload',
    title: 'New upload',
    description: '"City Lights" by The Mumbai Collective submitted for distribution',
    timestamp: '5 hours ago'
  },
  {
    id: '3',
    type: 'milestone',
    title: 'Milestone reached',
    description: '"Bollywood Nights" crossed 1M streams on Spotify',
    timestamp: '1 day ago'
  },
  {
    id: '4',
    type: 'artist_added',
    title: 'New artist added',
    description: 'Priya Saraiya joined your roster',
    timestamp: '2 days ago'
  },
  {
    id: '5',
    type: 'song_live',
    title: 'Song went live',
    description: '"Ocean Waves" is now available on 18 platforms',
    timestamp: '3 days ago'
  }
];

export const RecentActivity: React.FC = () => {
  const getIcon = (type: Activity['type']) => {
    switch (type) {
      case 'upload':
        return Upload;
      case 'song_live':
        return Music;
      case 'artist_added':
        return Users;
      case 'milestone':
        return TrendingUp;
      default:
        return Music;
    }
  };
  
  const getIconColor = (type: Activity['type']) => {
    switch (type) {
      case 'upload':
        return 'text-blue-400 bg-blue-500/10';
      case 'song_live':
        return 'text-green-400 bg-green-500/10';
      case 'artist_added':
        return 'text-purple-400 bg-purple-500/10';
      case 'milestone':
        return 'text-gold-400 bg-gold-500/10';
      default:
        return 'text-gray-400 bg-gray-500/10';
    }
  };
  
  return (
    <Card>
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-white font-display">Recent Activity</h3>
        <button className="text-gold-400 hover:text-gold-300 text-sm font-medium">
          View All
        </button>
      </div>
      
      <div className="space-y-4">
        {mockActivities.map((activity) => {
          const Icon = getIcon(activity.type);
          const iconColor = getIconColor(activity.type);
          
          return (
            <div key={activity.id} className="flex items-start space-x-3">
              <div className={`p-2 rounded-lg ${iconColor} flex-shrink-0`}>
                <Icon className="w-4 h-4" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-white">{activity.title}</p>
                <p className="text-sm text-gray-400 mt-1">{activity.description}</p>
                <p className="text-xs text-gray-500 mt-1">{activity.timestamp}</p>
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
};